/*! @pentacode/ui v0.1.0 */
import "./icon-DW8BBY5W.js";
import { t as e } from "./styledElement-DUAqv8gi.js";
import "./textarea-Cyvwmldp.js";
import { t } from "./reduced-motion.css-tEHc8kYn.js";
import { t as n } from "./css-build-DcREbovZ.js";
import { t as r } from "./decorateMetadata-BXz2gmG4.js";
import { t as i } from "./decorate-C_HUHFGG.js";
import { LitElement as a, html as o, nothing as s } from "lit";
import { customElement as c, property as l, state as u } from "lit/decorators.js";
// \0lit-plugin:css-sheet:./src/elements/assistant/assistant-chat-rating/assistant-chat-rating.css.js
var d = n("@starting-style{:host{opacity:0;filter:blur(1rem);transform:scale(.1)}}:host{opacity:1;filter:none;transform-origin:0 100%;border-radius:var(--border-radius,12px);background:var(--surface-document);border:1px solid var(--border-color,var(--shade-3));flex-direction:column;justify-content:center;place-self:center;gap:.5rem;max-width:max-content;padding:.5rem 1rem;font-size:.9rem;transition-property:opacity,display,filter,transform;transition-duration:.2s;display:flex;transform:none}.initial-display{justify-content:space-between;align-items:center;gap:2rem;display:flex}[part=rating-buttons]{align-items:center;gap:.5rem;display:flex}[part=rating-button]{box-shadow:none;border-radius:var(--radius-default,.5rem);cursor:pointer;background:0 0;border:none;place-content:center;align-self:end;width:2.25rem;height:2.25rem;transition:background .15s,color .15s;display:grid}[part=rating-button].positive{color:var(--color-positive)}[part=rating-button].negative{color:var(--color-negative)}[part=feedback]{border-top:1px solid var(--border-color,var(--shade-3));align-items:center;gap:.5rem;padding-top:.5rem;display:flex}[part=send-button]{background:var(--brand-blue);width:2.25rem;height:2.25rem;color:var(--color-bg-light);border-radius:var(--radius-default,.5rem);cursor:pointer;border:none;place-content:center;align-self:end;display:grid}[part=send-button]:disabled{opacity:.5;cursor:not-allowed}ptc-ui-textarea{--_textbox-radius:var(--border-radius,12px);--text-area-padding:.5em .75em}@starting-style{ptc-ui-textarea{opacity:0;filter:blur(1rem);transform:scale(.1)}}ptc-ui-textarea{outline:none;flex:1;transition-property:opacity,display,filter,transform;transition-duration:.2s}ptc-ui-textarea::part(container){scrollbar-color:var(--scrollbar-color) transparent}[part=rating-button].positive:hover,:host([sentiment=positive]) [part=rating-button].positive{color:var(--color-bg-light);background:var(--color-positive)}[part=rating-button].negative:hover,:host([sentiment=negative]) [part=rating-button].negative{color:var(--color-bg-light);background:var(--color-negative)}");
// src/elements/assistant/assistant-chat-rating/assistant-chat-rating.ts
function f(e, t) {
	let n;
	return function(...r) {
		clearTimeout(n), n = window.setTimeout(() => e(...r), t);
	};
}
var p = class extends e(a) {
	constructor(...e) {
		super(...e), this.styles = [d, t], this.state = "initial", this._feedback = "", this._feedbackRequired = !1, this._emitRatingChange = f(() => {
			this.sentiment && this.dispatchEvent(new CustomEvent("rating-change", {
				detail: {
					sentiment: this.sentiment,
					feedback: this._feedback
				},
				bubbles: !0,
				composed: !0
			}));
		}, 500);
	}
	_handleInput(e) {
		this._feedback = e, this._emitRatingChange();
	}
	_handleSubmit() {
		this.sentiment && this.dispatchEvent(new CustomEvent("rating-submit", {
			detail: {
				sentiment: this.sentiment,
				feedback: this._feedback
			},
			bubbles: !0,
			composed: !0
		}));
	}
	render() {
		return o`
            <div class="initial-display">
                <span part="question">Wie ist deine Erfahrung mit Yna?</span>
                <div class="rating-buttons" part="rating-buttons">
                    <button
                        class="positive"
                        part="rating-button"
                        aria-label="Gut"
                        title="Gut"
                        @click=${() => {
			this.sentiment = "positive", this._feedbackRequired = !1, this._emitRatingChange();
		}}
                    >
                        <ptc-ui-icon name="icon.status.approved"></ptc-ui-icon>
                    </button>
                    <button
                        part="rating-button"
                        class="negative"
                        aria-label="Schlecht"
                        title="Schlecht"
                        @click=${() => {
			this.sentiment = "negative", this._feedbackRequired = !0, this._emitRatingChange();
		}}
                    >
                        <ptc-ui-icon name="icon.status.rejected"></ptc-ui-icon>
                    </button>
                </div>
            </div>

            ${this.sentiment === void 0 ? s : o`
                      <div part="feedback">
                          <ptc-ui-textarea
                              part="textarea"
                              .autoGrow=${!0}
                              .maxRows=${5}
                              placeholder=${this.sentiment === "positive" ? "Was gefällt dir? Noch Wünsche?" : "Was war nicht so gut?"}
                              @input=${(e) => {
			this._handleInput(e.target.value);
		}}
                          ></ptc-ui-textarea>
                          <button
                              part="send-button"
                              title="Feedback senden"
                              ?disabled=${this._feedback.length === 0 && this._feedbackRequired}
                              @click=${this._handleSubmit}
                          >
                              <ptc-ui-icon name="icon.action.confirm"></ptc-ui-icon>
                          </button>
                      </div>
                  `}
        `;
	}
};
i([l({
	type: String,
	reflect: !0
}), r("design:type", String)], p.prototype, "state", void 0), i([l({
	type: String,
	reflect: !0
}), r("design:type", Object)], p.prototype, "sentiment", void 0), i([u(), r("design:type", String)], p.prototype, "_feedback", void 0), i([u(), r("design:type", Object)], p.prototype, "_feedbackRequired", void 0), p = i([c("ptc-ui-assistant-chat-rating")], p);
export { p as t };

//# sourceMappingURL=assistant-chat-rating-CmC8ZDeF.js.map